import { render, staticRenderFns } from "./DetalhesItensVencedoresLoteLicitacao.vue?vue&type=template&id=cea8b4b6"
import script from "./DetalhesItensVencedoresLoteLicitacao.vue?vue&type=script&lang=ts"
export * from "./DetalhesItensVencedoresLoteLicitacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports